import { render, staticRenderFns } from "./OnInvestmentTaxYN.vue?vue&type=template&id=1d6fdcb0"
import script from "./OnInvestmentTaxYN.vue?vue&type=script&lang=js"
export * from "./OnInvestmentTaxYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports